<template>
	<v-container
			class="customVContainer"
			:style="$_unauthorized_stylePageContainerStyle()"
			fluid>
		<template v-if="initialized_">
			<page-title-layout
					:inits="$_unauthorized_inits()" />
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</v-container>
</template>

<script>
	export default {
		name: 'Unauthorized',
		data() {
			return {
				pageName_: 'unauthorized',
				pageType_: 'unauthorized',

				initialized_: false
			}
		},
		computed: {
			// state
			$_unauthorized_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			// contents / inits
			$_unauthorized_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_unauthorized_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_unauthorized_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_unauthorized_inits(), 'contact')
			},
			// style
			$_unauthorized_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_unauthorized_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_unauthorized_inits(), 'pageContainer')
			},
			$_unauthorized_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_unauthorized_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_unauthorized_setPageState()

			if(self_.$_index_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_unauthorized_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_unauthorized_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_unauthorized_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_unauthorized_initialize()', error)
				})
			}
		}
	}
</script>

<style scoped>
</style>
